// Keap Certified Partner (keap_kcp-cert-5-fee-annual) price options per country.
// Mirrors KCP_OPTIONS in components/catalog-components/options.js — the value
// is the dollar amount, which is also the Recurly quantity ($1 unit x qty).
const buildOptions = (symbol, amounts) =>
  amounts.map(amount => ({
    value: String(amount),
    label: `${symbol}${amount.toLocaleString('en-US')}`,
    price: amount,
  }))

const KCP_OPTIONS_BY_COUNTRY = {
  US: buildOptions('$', [1500, 750, 499, 299]),
  CA: buildOptions('$', [405, 700, 1000, 2000]),
  AU: buildOptions('$', [418, 704, 1001, 2002]),
  NZ: buildOptions('$', [462, 770, 1100, 2200]),
  // Legacy label is '£1116' (no thousands separator) for the top GB option.
  GB: [
    ...buildOptions('£', [223, 372, 559]),
    {value: '1116', label: '£1116', price: 1116},
  ],
}

export const KCP_ANNUAL_PLAN_CODE = 'keap_kcp-cert-5-fee-annual'

export function getKcpOptions(country) {
  return KCP_OPTIONS_BY_COUNTRY[country] ?? []
}
